import { render, staticRenderFns } from "./AppRouter.vue?vue&type=template&id=6783b9c6&"
import script from "./AppRouter.vue?vue&type=script&lang=ts&"
export * from "./AppRouter.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports